import React from 'react';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import FormHelperText from '@material-ui/core/FormHelperText';
import Typography from '@material-ui/core/Typography';
import { commonStyles } from '../../styles/styles';
import PropTypes from 'prop-types';
import { MDBContainer, MDBRow, MDBCol, MDBCard, MDBCardBody, MDBInput, MDBBtn, MDBIcon, MDBModalFooter } from 'mdbreact';
import { API_LINK, STORAGE_LINK } from '../../constants';
import axios from 'axios';
import { connect } from 'react-redux';
import { loginReset, registrationRequest } from '../../redux/reducers/login';
import JsonListModal from '../JsonListModal';
import { setArea, setLastSchool } from '../../redux/reducers/view';
const API = `${API_LINK}api`;

const RenderText = ({ classes, meta, registrationForm, input, label, ...props }) => {
  {console.log('test reg 2',meta, input.name)}
  const conditionError = meta.error && meta.touched;

  const [value, setValue] = React.useState('');
  const [showList, showJsonList] = React.useState(false);
  const [data, setData] = React.useState([]);
 const onChange = (event) => {
    setValue(event.target.value);
    if(event.target.value.length>4 && label=="Search for Suburb (5 char)"){
      console.log('event area send',event.target.value.length, label)
      getArea()
    }
    if(event.target.value.length>4 && label=="Last School (min 5 chars)"){
      console.log('event school send',event.target.value)
      getSchools()
    }
    
   
  }

  const handleChoose = (event) => {
   
    input.value = event.name
    showJsonList(false)
    setValue(event.name);
    console.log('event choose',event)
    if(label=="Search for Suburb (5 char)"){
      console.log('event choose',event.id)
      props.setArea(event.id)
    }
    if(label=="Last School (min 5 chars)"){
      props.setLastSchool(event.id)
    }
  }

  const getSchools =  async() => {
    console.log('handel school doc', value)
   
    var result =  await axios({
      method: 'post',
      url: `${API}/searchReg`,
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        Authorization: `Bearer ${props.login.token}`,
      },
      params: {
        type: "school",
        searchStr: value
      }
    })
    console.log('result school',result.data)
    if(result.data.data.length > 0){
      setData(result.data.data);
      showJsonList(true)
      
    }
  }
  const getArea =  async() => {
    console.log('handel area doc', value)
   
    var result =  await axios({
      method: 'post',
      url: `${API}/searchReg`,
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        Authorization: `Bearer ${props.login.token}`,
      },
      params: {
        type: "area",
        searchStr: value
      }
    })
    console.log('result school',result.data)
    if(result.data.data.length > 0){
      setData(result.data.data);
      showJsonList(true)
      
    }
  }
  return (
    <FormControl
      className={`${classes.formField} ${registrationForm ? classes.regField : false}`}
      aria-describedby="name-error-text"
      error={conditionError}
    >
     
      <MDBInput
        {...input}
        name={input.name}
        onChange={onChange}
        value = {value}
        type="Text"
        label={label}
        error={conditionError}
        className={`${classes.formInput} ${conditionError ? classes.inputError : false}`}
        disableUnderline
        classes={{ focused: classes.formInputFocus }}
      />
      {conditionError && (
        <FormHelperText id="name-error-text" className={styles.errorBottomText}>
          {meta.error}
        </FormHelperText>
      )}
       {showList ? <div style={{position:'static', top:0, width:'100%',height:'100%', zIndex:10000000}}>
        <div style={{position:'fixed', top:0, left:0, width:'100%', height:'100%'}}><JsonListModal data={data} handleChoose={handleChoose}/></div>
      </div> : null}
    </FormControl>
  );
};

const styles = () => ({
  ...commonStyles,
});


const mapStateToProps = state => ({
  form: state.form,
  login: state.loginReducer,
  dropdowns: state.dropdownsReducer,

});
const mapDispatchToProps = dispatch => ({
  setLastSchool: (id) => dispatch(setLastSchool(id)),
  setArea: (id) => dispatch(setArea(id)),
});

export default compose(withStyles(styles),
connect(mapStateToProps, mapDispatchToProps))(RenderText);
